import { useState } from "react";
import "./Tabs.css";

function Tabs({ tabs = [], defaultKey }) {
    const [activeKey, setActiveKey] = useState(defaultKey || tabs[0]?.key);
    const activeTab = tabs.find((tab) => tab.key === activeKey) || tabs[0];

    return (
        <div className="tabs">
            <div className="tabs_bar">
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        className={"tabs_item" + (tab.key === activeKey ? " tabs_item-active" : "")}
                        onClick={() => setActiveKey(tab.key)}
                    >
                        {tab.icon && <i className={tab.icon}></i>}
                        {tab.label}
                    </button>
                ))}
            </div>
            <div className="tabs_content">
                {activeTab?.content}
            </div>
        </div>
    );
}

export default Tabs;
